import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import Tab from '@mui/material/Tab'
import CompanyAbout from '../CompanyAbout'
import { CompanyListedShares } from '../CompanyShare'
import { EventSummaryContainer } from './EventSummaryContainer'
import { SELECTED_ISSUE_ROUTE_PARAM } from '.'
import { useSearchParams } from 'react-router'
import Card from '@mui/material/Card'
import { atom, useAtom } from 'jotai'

export const SELECTED_TAB_ROUTE_PARAM = 'tab'
const TABS = ['about-share', 'about-company', 'selected-event']

const getSelection = (queryVal: string | null) => {
    const [type, id] = queryVal?.split('__') || []

    if (type !== 'warrant' && type !== 'issue' && type !== 'split') return []

    return [type, id] as ['warrant' | 'issue' | 'split', string]
}

const getSelectedTab = (queryStr: string | null) => {
    return TABS.find((t) => t === queryStr) || TABS[0]
}

export const selectedTabAtom = atom(getSelectedTab(null))

export const CompanyTabs = () => {
    const { t } = useTranslation()
    const [searchParams] = useSearchParams()
    const [selectedTab, setSelectedTab] = useAtom(selectedTabAtom)
    const [selectedEventType, selectedEventId] = getSelection(searchParams.get(SELECTED_ISSUE_ROUTE_PARAM))

    useEffect(
        () => () => {
            setSelectedTab('about-share') // Reset on unmount
        },
        [setSelectedTab],
    )

    const handleSelectTab = (tab: string) => {
        setSelectedTab(tab)
    }

    return (
        <Card sx={{ height: '100%' }}>
            <TabContext value={selectedTab}>
                <TabList onChange={(e, v) => handleSelectTab(v)}>
                    <Tab value='about-share' label={t('pages.companies.tabs.aboutShare')} />
                    <Tab value='about-company' label={t('pages.companies.tabs.aboutCompany')} />
                    <Tab value='selected-event' label={t('pages.companies.tabs.selectedEvent')} />
                </TabList>

                <TabPanel value='about-share' sx={{ paddingY: 0 }}>
                    <CompanyListedShares />
                </TabPanel>
                <TabPanel value='about-company' sx={{ paddingY: 0 }}>
                    <CompanyAbout />
                </TabPanel>
                <TabPanel value='selected-event' sx={{ paddingY: 0 }}>
                    <EventSummaryContainer eventType={selectedEventType} id={selectedEventId} />
                </TabPanel>
            </TabContext>
        </Card>
    )
}
